import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, createVNode as _createVNode, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column email-login"
}
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "d-flex flex-column gap-sm" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = {
  for: "email",
  class: "form-label text-capitalize-first"
}
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "" }
const _hoisted_8 = {
  for: "password",
  class: "form-label text-capitalize-first"
}
const _hoisted_9 = { class: "password-input" }
const _hoisted_10 = ["type", "placeholder"]
const _hoisted_11 = { class: "d-flex flex-column gap-sm" }
const _hoisted_12 = { class: "form-check d-flex align-items-start" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "register-here" }
const _hoisted_16 = {
  key: 1,
  class: "d-flex flex-column email-login"
}
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { class: "text-center d-flex justify-content-center" }
const _hoisted_19 = { class: "mail-icon" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "info" }
const _hoisted_22 = ["disabled"]

import {reactive} from "@vue/reactivity";
import {api} from "@/service/APIClient";
import {computed, onBeforeUnmount, ref} from "vue";
import {useNotification} from "@kyvg/vue3-notification";
import {$t} from "@/i18n";
import SvgIcon from "@/components/SvgIcon.vue";
import LoaderContent from "@/components/LoaderContent.vue";
import RegisterRequestDTO from "@/models/request/RegisterRequestDTO";

const RESEND_COOLDOWN_SECONDS = 60;


export default /*@__PURE__*/_defineComponent({
  __name: 'EmailRegistration',
  setup(__props) {

const state = reactive({
  email: '' as string,
  password: '' as string,
  showPassword: false as boolean,
  termsAccepted: false as boolean,
  emailIsSent: false as boolean,
  resendCountdown: 0 as number,
});

const canSubmit = computed(() => {
  return state.email.length > 0 && state.password.length >= 8 && state.termsAccepted;
})

const loader = ref<InstanceType<typeof LoaderContent> | null>(null)
const notification = useNotification()
let countdownInterval: number|any = null;

const startCountdown = () => {
  state.resendCountdown = RESEND_COOLDOWN_SECONDS;
  countdownInterval = setInterval(() => {
    state.resendCountdown--;
    if (state.resendCountdown <= 0) {
      clearInterval(countdownInterval);
    }
  }, 1000);
}

const register = async () => {
  if (!canSubmit.value) {
    return;
  }

  loader.value?.load(async () => {
    try {
      const result = await api.call.token.register({email: state.email, password: state.password} as RegisterRequestDTO)
      state.email = result.email
      state.emailIsSent = true
      notification.notify({type: 'success', title: $t('notifications.verification_email_sent'), duration: 1500})
      startCountdown()
    } catch (e: any) {
      if (e.response?.data?.[0]?.code === 'EMAIL_TAKEN') {
        notification.notify({type: 'error', title: $t('notifications.email_already_registered'), duration: 1500})
      } else {
        notification.notify({type: 'error', title: $t('notifications.registration_error'), duration: 1500})
      }
    }
  });
}

const resend = async () => {
  if (state.resendCountdown > 0) {
    return;
  }

  loader.value?.load(async () => {
    try {
      await api.call.token.resendVerification(state.email)
      notification.notify({type: 'success', title: $t('notifications.verification_email_sent'), duration: 1500})
    } catch (e) {}
    startCountdown()
  });
}

onBeforeUnmount(() => {
  if (countdownInterval) {
    clearInterval(countdownInterval);
  }
})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(LoaderContent, {
    ref: (el) => loader.value = el
  }, {
    default: _withCtx(() => [
      (!_unref(state).emailIsSent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h1", null, _toDisplayString(_unref($t)('create_account')), 1)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("label", _hoisted_5, _toDisplayString(_unref($t)('email')), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).email) = $event)),
                  id: "email",
                  type: "email",
                  class: "form-control",
                  placeholder: _unref($t)('enter_email')
                }, null, 8, _hoisted_6), [
                  [_vModelText, _unref(state).email]
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, _toDisplayString(_unref($t)('password')), 1),
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).password) = $event)),
                    id: "password",
                    type: _unref(state).showPassword ? 'text' : 'password',
                    class: "form-control",
                    placeholder: _unref($t)('enter_password')
                  }, null, 8, _hoisted_10), [
                    [_vModelDynamic, _unref(state).password]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "password-toggle",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_unref(state).showPassword = !_unref(state).showPassword), ["prevent"]))
                  }, [
                    _createVNode(SvgIcon, {
                      icon: _unref(state).showPassword ? 'eye-off' : 'eye'
                    }, null, 8, ["icon"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(state).termsAccepted) = $event)),
                  type: "checkbox",
                  class: "form-check-input"
                }, null, 512), [
                  [_vModelCheckbox, _unref(state).termsAccepted]
                ]),
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(_unref($t)('terms_notice_prefix')) + " ", 1),
                  _createVNode(_component_router_link, {
                    to: {name: 'termsOfUse'},
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref($t)('terms_of_use_link')), 1)
                    ]),
                    _: 1
                  }),
                  _cache[6] || (_cache[6] = _createTextVNode(" and ")),
                  _createVNode(_component_router_link, {
                    to: {name: 'privacyPolicy'},
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref($t)('privacy_policy_link')), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (register()), ["prevent"])),
                disabled: !canSubmit.value,
                class: "btn btn-primary w-100 btn-lg"
              }, _toDisplayString(_unref($t)('sign_up')), 9, _hoisted_13)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_router_link, { to: {name:'emailLogin'} }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_unref($t)('already_have_account')), 1),
                  _cache[7] || (_cache[7] = _createTextVNode()),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_unref($t)('log_in')), 1)
                ]),
                _: 1,
                __: [7]
              })
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("h1", null, _toDisplayString(_unref($t)('check_your_email')), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(SvgIcon, { icon: "mail" })
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("span", _hoisted_21, _toDisplayString(_unref($t)('confirmation_email_sent', {email: _unref(state).email})), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (resend()), ["prevent"])),
                disabled: _unref(state).resendCountdown > 0,
                class: "btn btn-secondary w-100 btn-lg"
              }, _toDisplayString(_unref(state).resendCountdown > 0 ? _unref($t)('resend_email_countdown', {seconds: _unref(state).resendCountdown}) : _unref($t)('resend_email')), 9, _hoisted_22)
            ])
          ]))
    ]),
    _: 1
  }, 512))
}
}

})